import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { View, TouchableOpacity } from 'react-native'
import { createContainer } from '@dbk-legacy/muster/react'
import Text from '@dbk/ui-text'
import Modal from '@dbk/ui-modal'
import costsList from '../../../../data/payment-costs-list.json'
import { Info } from '@dbk/ui-icons'
import { PALETTE } from '../../../../constants'

class PymtCharge extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      costsModalVisible: false,
    }

    this.handleIconPress = this.handleIconPress.bind(this)
    this.handleDone = this.handleDone.bind(this)
  }

  componentDidUpdate(){
    if(document.querySelector('.focusForFeesHeading')){
      document.querySelector('.focusForFeesHeading').focus();
    }
  }

  handleIconPress() {
    this.setState({
      costsModalVisible: true,
    })
  }

  handleDone() {
    this.setState({
      costsModalVisible: false,
    })
    this.forceUpdate()
  }

  render() {
    const {
      i18n: { messages },
    } = this.props
    const { costsModalVisible } = this.state
    const costs = costsList.costsList

    return (
      <View style={{ alignSelf: 'flex-end', position: 'relative', bottom: 3 }}>
        <TouchableOpacity onPress={this.handleIconPress}>
          <div style={{ marginLeft: 5 }} aria-label={messages['app.payments.feeschargeOptions'] +" " + messages["app.dashboard.toolTip"]}>
            <Info width={18} height={18} color={PALETTE.primaryText}/>
          </div>
        </TouchableOpacity>
        <View>
          <Modal
            isActive={costsModalVisible}
            onClose={this.handleDone}
            header={<div className="focusForFeesHeading" tabIndex={0}><Text secondary>{messages['app.payments.feeschargeOptions']}</Text></div>}
            className={"model-window-login"}
            content={
              <div>
                {costs && costs.length &&
                costs.map((val, i) => (
                  <div key={val.id} style={{ margin: 20, marginLeft:40 }}>
                    <div tabIndex={0} className={i === 0 ? 'chargeOptionFocus': ""}><Text secondary>{messages[val.title]}</Text></div>
                    <div tabIndex={0}><Text>{messages[val.desc]}</Text></div>
                  </div>
                ))}
              </div>
            }
          />
        </View>
      </View>
    )
  }
}

PymtCharge.propTypes = {
  i18n: PropTypes.object.isRequired,
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  },
})(PymtCharge)
